import React, { useContext} from 'react'

//Components
import Footer from 'components/Footer'
import Header from 'components/Header'
import MainNav from 'components/MainNav'
import Message from 'components/Message'

//Styles
import styles from './DocumentationLayout.module.scss'

//Context
import { MessagesState, MessagesDispatch } from 'context/messages-context'

//Types
import { DocsetInfo } from 'types/docset'

//Hooks
import { useIsSmallDevice } from 'hooks'

interface Props {
  sidebarVisible: boolean,
  toggleSidebar: () => void,
  title?: string,
  linkTitle?:string
  defaultLink?: string
  version?: string
  versionPicker?: React.ReactNode
  info?: DocsetInfo
  pdf?: string
  side?: React.ReactNode
  content: React.ReactNode
  onSearchClick?: () => void
  onPDFDownloadClick?: () => void
  minimal?: boolean
}

const DocumentationLayout = ({sidebarVisible, toggleSidebar, title, linkTitle, defaultLink, version, versionPicker, info, pdf, side, content, onSearchClick, minimal, onPDFDownloadClick}:Props) => {
  const isSmallDevice = useIsSmallDevice()
  
  

  const messages = useContext(MessagesState)
  const messagesDispatch = useContext(MessagesDispatch)

  return (
    <div className={styles.documentation}>

      <header className={styles.header} role="banner">
        { !isSmallDevice && <Header /> }
        <MainNav
          title={title}
          linkTitle={linkTitle}
          defaultLink = {defaultLink}
          version={version}
          versionPicker={versionPicker}
          info={info}
          pdf={pdf}
          hideSidebarToggle={!side}
          onSidebarToggleClick={() => toggleSidebar()}
          sidebarVisible={sidebarVisible}
          onSearchClick={onSearchClick}
          onPDFDownloadClick={onPDFDownloadClick}
          minimal={minimal}
        />
      </header>
      {
        messages.map(message => (
          <Message key={message.key} content={message.content} style={message.style} closeable={message.closeable} onClose={() => messagesDispatch({ type: 'remove', message: message})}></Message>
        ))
      }
      <div className={styles.main}>
        { side && sidebarVisible && <div className={`${styles.sidebarContainer} ${isSmallDevice && styles.smallDevice}`}><nav className={`${styles.side} `} role="none">{ side }</nav></div> }
        <div className={styles.content}>
          { content }
        </div>
      </div>
      <footer className={styles.footer}>
        <Footer/>
      </footer>
    </div>
  )
}

export default DocumentationLayout